import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import {
  TextField,
} from '@material-ui/core';
import MainTitle from '../../../../components/MainTitle';
import ButtonBase from '../../../../components/Buttons/ButtonBase';
import TitlesProfile from '../../../../components/Profile/TitlesProfile';
import CoverPhotosModal from '../../../../components/Modal/CoverPhotosModal';
import {
  cleanProposalData,
  loadProposalData,
  setProposalSelected,
} from '../../../../store/actions/ProposalsAction';
import { TEMPLATE11_COVERS, TEMPLATE12_COVERS, TEMPLATE13_COVERS, TEMPLATE14_COVERS, TEMPLATE15_COVERS } from '../../../../utils/CoverImages';
import './ProposalCover.scss';

import FaceLook from '../../../Profile/FaceLook';
const useStyles = makeStyles({
  ButtonBase: {
    padding: 0,
    margin: 0,
    width: 192,
    minWidth: 'initial',
    '@media (max-width: 768px)': {
      width: 144,
    },
  },
  TextField: {
    maxWidth: '100%',
    margin: 0,
  },
  linkStyle: {
    width: 192,
    margin: '0 24px 0 0',
    '&:last-child': {
      margin: 0,
    },
    '@media (max-width: 768px)': {
      width: 144,
    },
  },
});

const ProposalCover = ({
  setStep,
  setCreateView,
  valuesToEdit,
  proposalData,
  cleanProposalData,
  loadProposalData,
  setProposalSelected,
}) => {

let  modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline'],
      ['clean']
    ],
  }

  const isMobile = useMediaQuery('(max-width: 768px)');
  const classes = useStyles();

  const [openModal, setOpenModal] = useState(false);
  const [urlCover, setUrlCover] = useState();
  const [error, setErrorQuill] = useState(false);

  let coverList;
  switch (proposalData.templateId || valuesToEdit.templateId) {
    case 0:
      coverList = TEMPLATE11_COVERS;
      break;
    case 1:
      coverList = TEMPLATE12_COVERS;
      break;
    case 2:
      coverList = TEMPLATE13_COVERS;
      break;
    case 3:
      coverList = TEMPLATE14_COVERS; 
      break;
    case 4: 
      coverList = TEMPLATE15_COVERS;
      break;
    default:
      coverList = TEMPLATE11_COVERS;
      break;
  }
  const [templateNumber, setTemplateNumber] = useState(coverList[0].templateNumber);
  const [coverOnPreview, setCoverOnPreview] = useState(coverList[0].id || 1);
  const [imgenPortada, setimgenPortada] = useState( coverList[0].id || 1);
  const defaultCover = coverList[0].pathImg;
  const imgCover = undefined;
  const selectCover = () => {
    setUrlCover(`/img/profile/cover/${imgenPortada}.jpg`);

    setCoverOnPreview(imgenPortada);
    handleCloseModal();
  };
  const cancelCover = () => {
    //setUrlCover(null);
    //setCoverOnPreview((authClient && authClient.imgenPortada && authClient.imgenPortada) || 23);
    handleCloseModal();
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const revisar = (elemento) => {
    setimgenPortada(elemento);
  };

  const getTemplateNumber = (id) => {
    setTemplateNumber(id)
  }

  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [introduction, setIntroduction] = useState('');

  const validateQuill = (value) => {
    if (value && value !== '<p><br></p>') {
      return true;
    } else {
      return false;
    }
  };


  const validateText = (value) => {
    const regExpStr = "^([A-Za-zäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑ ]{1,35})$"
    const result = new RegExp(regExpStr) 
    if (result.test(value)) {
      return true;
    } else {
      return false;
    }
  };

  const validatesubTitle  = (value) => {
    const regExpStr = "^([A-Za-zäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑ ]{1,45})$"
    const result = new RegExp(regExpStr) 
    if (result.test(value)) {
      return true;
    } else {
      return false;
    }
  };
  

  const handleSubmit = () => {

   


    if(valuesToEdit && Object.values(valuesToEdit).length > 0) {
      const newProposalData = {
        ...valuesToEdit,
        coverImage: imgenPortada,
        title: title,
        subTitle: subtitle,
        introduction: introduction,
        templateNumber: templateNumber,
      };
      setProposalSelected(newProposalData);
    } else {
      const newProposalData = {
        ...proposalData,
        coverImage: imgenPortada,
        title: title,
        subTitle: subtitle,
        introduction: introduction,
        templateNumber: templateNumber,
      };
      loadProposalData(newProposalData);
    }
    window.scroll(0, 0);
    setStep(3); 
  };


  const handleCancel = () => {
    setTitle('');
    setSubtitle('');
    setIntroduction('');
    cleanProposalData();
    setCreateView(false);
    window.scroll(0, 0);
  };

  const handleChangeTitle = (event) => {
    setTitle(event.target.value);
  };

  const handleChangeSubtitle = (event) => {
    setSubtitle(event.target.value);
  };

  const handleChangeIntroduction = (content, delta , source ,editor ) => {
    let count = editor.getText();
    let dirtyHtml = editor.getHTML()
    console.log("dirtyHtml=",dirtyHtml);
    let cleanHtml= dirtyHtml.replaceAll("<p><br></p>", '');
    console.log("cleanHtml=",cleanHtml);

    cleanHtml= cleanHtml.replaceAll('<p class="ql-align-justify"><br></p>', '');


    if (count.length >= 300) {
      setErrorQuill(true)
    }else {
      setErrorQuill(false)
    }
    setIntroduction(cleanHtml);
  };

  const handleCover = (myActualValues) => {
    const isSameTemplate = coverList.find(cover => cover.templateNumber === myActualValues.templateNumber)
    setCoverOnPreview(isSameTemplate? myActualValues.coverImage : coverList[0].id)
    setimgenPortada(isSameTemplate? myActualValues.coverImage : coverList[0].id)
    setUrlCover(`/img/profile/cover/${isSameTemplate? myActualValues.coverImage : coverList[0].id}.jpg`);
  }

  useEffect(() => {
    if(valuesToEdit && Object.values(valuesToEdit).length > 0){
      console.log('valuesToEdit', valuesToEdit)
      console.log('coverlist',coverList)
      if(valuesToEdit.coverImage) {
        handleCover(valuesToEdit);
      }
      valuesToEdit.title && setTitle(valuesToEdit.title)
      valuesToEdit.subTitle && setSubtitle(valuesToEdit.subTitle)
      valuesToEdit.introduction && setIntroduction(valuesToEdit.introduction)
    }
    if(proposalData && Object.values(proposalData).length > 0){
      if(proposalData.coverImage) {
        handleCover(proposalData);
      }
      proposalData.title && setTitle(proposalData.title)
      proposalData.subTitle && setSubtitle(proposalData.subTitle)
      proposalData.introduction && setIntroduction(proposalData.introduction)
    }
  }, [valuesToEdit, proposalData])


  return (
    <>
      <div className="ProposalCover">
        <div className="ProposalCover_header">
          <div
            className="ProposalCover_header_arrowBack"
            onClick={() => setStep(1)}
          >
            <img src="/img/admin/arrow-back.svg" alt="arrow-back" />
            <p>Regresar</p>
          </div>
          <div className="ProposalCover_header_title">
            <MainTitle
              title="Carátula de propuesta económica"
              subtitle="Puedes agregar una carátula a tu propuesta económica con la siguiente información."
            />
          </div>
        </div>

        <div className="ProposalCover_content">
          <div className="ProposalCover_content_section">
            <TitlesProfile
              title="Imagen de carátula"
              subtitle="Mantén o cambia la imagen de carátula para la creación de la propuesta económica."
            />

            <div
              className="ProposalCover_cover_container"
              style={{
                backgroundImage: `url(${
                  imgCover
                    ? !urlCover
                      ? imgCover
                      : urlCover
                    : !urlCover
                    ? defaultCover
                    : urlCover
                })`,
              }}
              onClick={() => setOpenModal(true)}
            >
              <div className="look_container_add">
                <img
                  className="insertar-foto"
                  src="/img/profile/insertar-foto.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="ProposalCover_content_section">
            <TitlesProfile
              title="Título"
              subtitle="Agrega el título para la carátula de la propuesta económica."
            />
            <TextField
            required
            name={`Titulo`}
            type="text"
            InputLabelProps={{ shrink: true }}
            onChange={handleChangeTitle}
            value={title}
                     inputProps={{maxLength :35}}

            helperText={
            
              ''
            }
            error={
                false
            }
            classes={{ root: classes.TextField }}
            label="Título para la carátula de la propuesta económica"
            variant="outlined"
          />
       


            
          </div>
          <div className="ProposalCover_content_section">
            <TitlesProfile
              title="Subtítulo"
              subtitle="Agrega el subtítulo para la carátula de la propuesta económica."
            />

             <TextField
                name={`Subtítulo`}
                type="text"
                InputLabelProps={{ shrink: true }}
                onChange={handleChangeSubtitle}
                value={subtitle}
                         inputProps={{maxLength :35}}

                helperText={

                  ''
                }
                error={
                    false
                }
                classes={{ root: classes.TextField }}
                label="Subtítulo para la carátula de la propuesta económica"
                variant="outlined"
                />
           
          </div>
          <div className="ProposalCover_content_section">
            <TitlesProfile
              title="Texto de introducción"
              subtitle="Texto introductorio para exponer la experiencia, misión o visión del abogado."
            />
            <ReactQuill
              className="ProposalCover_reactQuill"
              theme="snow"
              modules={modules}
              onChange={handleChangeIntroduction}
              value={introduction}
            />
            
            { error ? <p className="text_error_quill"> Cantidad de caracteres excedida  </p> : <p className="text_help_quill"> Agrega 300 caracteres máximo </p>}
          </div>

          <div className="ProposalCover_content_buttons">
            <ButtonBase
              type="submit"
              onClick={handleSubmit}
              variant="primary"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase}
              disabled={
                validateText(title) &&
                validatesubTitle(subtitle) &&
                validateQuill(introduction)
                  ? false
                  : true
              }
            >
              {isMobile ? 'Guardar' : 'Guardar y continuar'}
            </ButtonBase>

            <ButtonBase
              type="submit"
              onClick={handleCancel}
              variant="primarySolidOutlined"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase}
            >
              Cancelar
            </ButtonBase>
          </div>
        </div>
      </div>
      <CoverPhotosModal
        checkValue={revisar}
        open={openModal}
        handleClose={handleCloseModal}
        selectCover={selectCover}
        cancelCover={cancelCover}
        coverOnPreview={coverOnPreview}
        coversContainer={
          <FaceLook
            checkValue={revisar}
            coverOnPreview={coverOnPreview}
            covers={coverList}
            getTemplateNumber={getTemplateNumber}
          />
        }

      />
    </>
  );
};

const mapStateToProps = (state) => ({
  uid: state.authClient.uid,
  valuesToEdit: state.proposalsReducer.selectedProposal,
  proposalData: state.proposalsReducer.newProposalData,
});
const mapDispatchToProps = (dispatch) => ({
  cleanProposalData: () => dispatch(cleanProposalData()),
  loadProposalData: (proposalData) => dispatch(loadProposalData(proposalData)),
  setProposalSelected: (proposalData) =>
    dispatch(setProposalSelected(proposalData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProposalCover);
